import { WarningFilled } from '@ant-design/icons'
import { Modal, List } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'

type DownloadWarningModalPropsType = {
    fileNames?: string[]
    visible: boolean
    onClose: () => void
    onConfirm: (
        evt: Event,
        fileName?: string,
        url?: string,
    ) => Promise<void> | void
}

const TEXT_COLOR = 'blackAlpha65'
const PLACEMENT = 'download-warning-modal'
const MULTIPLE_FILES_WARNING_TEXT =
    'The following files are not recognized by our system. Are you sure you want to download them? '
const SINGLE_FILE_WARNING_TEXT =
    'This file is not recognized by our system. Are you sure you want to download it? '

const renderItem = (fileName: string) => (
    <List.Item style={{ padding: 0, marginTop: 8 }}>- {fileName}</List.Item>
)

export default function DownloadWarningModal(
    props: DownloadWarningModalPropsType,
) {
    const { fileNames, visible, onClose, onConfirm } = props

    return (
        <Modal
            width="558px"
            bodyStyle={{ padding: '32px 16px 24px 32px 128px' }}
            centered
            closable={false}
            footer={null}
            visible={visible}
            onCancel={onClose}
            maskClosable
        >
            <Box>
                <WarningFilled
                    style={{
                        color: getColor('warning'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        color={TEXT_COLOR}
                        style={{
                            maxWidth: '451px',
                        }}
                    >
                        {fileNames?.length
                            ? MULTIPLE_FILES_WARNING_TEXT
                            : SINGLE_FILE_WARNING_TEXT}
                    </Text>
                    {Boolean(fileNames?.length) && (
                        <List
                            dataSource={fileNames}
                            renderItem={renderItem}
                            split={false}
                            style={{ margin: '8px 0' }}
                            size="small"
                        />
                    )}
                    <Box justifyContent="end" marginTop="32px">
                        <Button
                            onClick={onClose}
                            name={`${PLACEMENT}-cancel`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-cancel`}
                            style={{ marginRight: '8px' }}
                        >
                            Cancel download
                        </Button>
                        <Button
                            type="primary"
                            onClick={e => {
                                onConfirm(e)
                            }}
                            name={`${PLACEMENT}-save`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-save`}
                        >
                            Continue download
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
